import React from 'react';
import {
  EV_FIRES_PER_100K, GAS_FIRES_PER_100K_LABEL, AVG_DAILY_MILES,
  PUBLIC_CHARGING_LOCATIONS_K, ORIGINAL_PACK_MILES_K,
} from '../../config/stats';

// The numbers that end most EV arguments. Values live in config/stats.js.
const STATS = [
  { n: EV_FIRES_PER_100K, k: false, tone: 'red', label: `EV fires per 100,000 sold. Gas cars: about ${GAS_FIRES_PER_100K_LABEL}.` },
  { n: AVG_DAILY_MILES, k: false, tone: '', label: 'Miles the average American drives a day.' },
  { n: PUBLIC_CHARGING_LOCATIONS_K, k: true, tone: '', label: 'Public charging locations in the US.' },
  { n: ORIGINAL_PACK_MILES_K, k: true, tone: 'blue', label: 'Miles EVs are hitting on the original battery.' },
];

export default function MileMarkers() {
  return (
    <section className="fi-nums" aria-label="Mile markers">
      <div className="fi-wrap">
        <h2 className="fi-nums-t fi-ant">Mile markers</h2>
        {STATS.map((s) => (
          <div className="fi-stat" key={s.label}>
            <div
              className={`fi-num${s.k ? ' fi-num--k' : ''}${s.tone ? ` fi-num--${s.tone}` : ''}`}
              style={{ '--fi-n': s.n }}
              aria-hidden="true"
            />
            <span className="fi-sr">{s.n}{s.k ? 'K' : ''}</span>
            <span className="fi-lab">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
